import type { NavigatablePath } from '@/router/routes';
import { useNavigate } from 'react-router-dom';

/**
 * 타입 안전한 네비게이션 훅
 * 정의된 경로만 네비게이션할 수 있도록 타입 체크를 제공합니다.
 */
export function useTypedNavigate() {
  const navigate = useNavigate();

  return (
    path: NavigatablePath,
    options?: { replace?: boolean; state?: unknown }
  ) => {
    navigate(path, options);
  };
}
